import { PersianNum } from "./PersianNum";

export const getTimeAgo = (dateString: any) => {
  const date: any = new Date(dateString);
  const now: any = new Date();
  const differenceInMilliseconds = now - date;

  const oneMinuteInMilliseconds = 60 * 1000;
  const oneHourInMilliseconds = 60 * oneMinuteInMilliseconds;
  const oneDayInMilliseconds = 24 * oneHourInMilliseconds;
  const oneMonthInMilliseconds = 30 * oneDayInMilliseconds;
  const oneYearInMilliseconds = 12 * oneMonthInMilliseconds;

  if (differenceInMilliseconds < oneDayInMilliseconds) {
    const hours = Math.floor(differenceInMilliseconds / oneHourInMilliseconds);
    if(hours === 0) return "چند دقیقه پیش"
    return `${PersianNum(hours)} ساعت پیش`;
  } else if (differenceInMilliseconds < oneMonthInMilliseconds) {
    const days = Math.floor(differenceInMilliseconds / oneDayInMilliseconds);
    return `${PersianNum(days)} روز پیش`;
  } else if (differenceInMilliseconds < oneYearInMilliseconds) {
    const months = Math.floor(
      differenceInMilliseconds / oneMonthInMilliseconds
    );
    return `${PersianNum(months)} ماه پیش`;
  } else {
    const years = Math.floor(differenceInMilliseconds / oneYearInMilliseconds);
    return `${PersianNum(years)} سال پیش`;
  }
};
